import { fetchAuthSession } from 'aws-amplify/auth';

class TokenService {
  static readonly obter = async (): Promise<string | undefined> => {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  }
}

export default TokenService